import { formatSuffixedParams } from "@backpacker/intl";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import { Card } from ".";

export function getCardTitle(card: Card, locale: Locale) {
  return {
    ...card,
    title: !!card.dynamicTitle
      ? tr(
          locale,
          "" + card.dynamicTitle.key,
          formatSuffixedParams(card.dynamicTitle.params, locale)
        )
      : card.title,
  };
}
